import envConfig from '../../static/config';
import config from '../config';
import FinancialStoriesStore from '../stores/FinancialStoriesStore';
import ApiUtils from './ApiUtils';
import ProjectionActionCreator from '../actions/ProjectionActionCreator';
import AccountsActionCreator from '../actions/AccountsActionCreator';

const projectionPreferencesUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/projection/preferences';
const projectionCreateUpdateUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/projection/preferences';
const _getProjectionEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/projection';

const ProjectionApiUtils = {
  getAccountId() {
    return FinancialStoriesStore.getCurrentAccountId();
  },
  /**
   * API call for get projection preferences.
   * Retrieves the projection preferences of the customer.
   */
  getProjectionSummary(accountId) {
    let url = envConfig.apiBaseUrlPAAS + _getProjectionEndpoint;
    url = url.replace('{account-id}', accountId);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.projectionService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        ProjectionActionCreator.handleProjectionSummarySuccess(
          body,
          status,
          accountId
        );
        AccountsActionCreator.handleDangerPeriodDataSuccess(
          body,
          accountId,
          status
        );
      },
      (error, status) => {
        if (status === 404) {
          const obj = {
            projection_periods: [
              {
                warning_days: [],
              },
            ],
          };
          AccountsActionCreator.handleDangerPeriodDataSuccess(
            obj,
            accountId,
            status
          );
        }
        ProjectionActionCreator.handleProjectionSummaryFailure(
          error,
          status,
          accountId
        );
      }
    );
  },
  getEarningCommitments(id) {
    const _getprojectionPreferenceUrl = projectionPreferencesUrl.replace(
      '{account_id}',
      id
    );
    let url = envConfig.apiBaseUrlPAAS + _getprojectionPreferenceUrl;
    if (envConfig.stubConfig) {
      url =
        envConfig.stubConfig.projectionsStub.ProjectionEarningsAndCommitments;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.projectionService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        ProjectionActionCreator.handleEarningsCommitmentSuccess(body);
      },
      (error) => {
        ProjectionActionCreator.handleEarningsCommitmentError(error);
      }
    );
  },
  /**
   * API call for creates/updates the  projection preferences.
   * creates or updates the projection preferences of the customer.
   */
  projectionsUpdate(dProjectionObjects, id) {
    const requestData = dProjectionObjects;
    const _updateProjectionPreferences = projectionCreateUpdateUrl.replace(
      '{account_id}',
      id
    );
    const url = envConfig.apiBaseUrlPAAS + _updateProjectionPreferences;
    // if (envConfig.stubConfig) {
    // 	url = envConfig.stubConfig.projectionsStub.ProjectionEarningsAndCommitments;
    // }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.projectionService,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body, status) => {
        ProjectionActionCreator.handleProjectionDoneSuccess(body, status, id);
      },
      (error, status) => {
        ProjectionActionCreator.handleProjectionDoneError(error, status, id);
      }
    );
  },
};
export default ProjectionApiUtils;
